import { render, staticRenderFns } from "./ModalDocumentosAdicionarVariosBemTerceiro.vue?vue&type=template&id=8f89c43e"
import script from "./ModalDocumentosAdicionarVariosBemTerceiro.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosAdicionarVariosBemTerceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports